import React, { useState, useEffect } from "react";
import "./skuManagement.scss";
import {
	Button,
	Loader,
	Modal,
	SelectPicker,
	toaster,
	Notification,
} from "rsuite";
import { numberFormatter } from "../../utils";

const ProductTaxonomy = (props: any) => {
	const tree = props.skuTree;
	const selected = props.selection;
	const leanageValue = props.leanageValue;
	const relevantAttributes = props.relevantAttributes;

	console.log("relevantAttributes", relevantAttributes);

	const handleItemClick = (
		itemName: string,
		level: string,
		index: number,
		attributekey: any
	) => {
		props.handleClick(itemName, level, index, attributekey);
	};

	const [categories, setCategories] = useState<any>({
		l1: new Array<{ l1: string }>(),
		l2: new Array<{ l2: string }>(),
		l3: new Array<{ l3: string }>(),
		l4: new Array<{ l4: string }>(),
		l5: new Array<{ l5: string }>(),
		l6: new Array<{ l6: string }>(),
		l7: new Array<{ l7: string }>(),
		l8: new Array<{ l8: string }>(),
		// Type: new Array<{ Type: string }>(),
		// Material: new Array<{ Material: string }>(),
		// Finish: new Array<{ Finish: string }>(),
		// Configuration: new Array<{ Configuration: string }>(),
		// Throat_Type: new Array<{ Throat_Type: string }>(),
		// Trade_Size_Class: new Array<{ Trade_Size_Class: string }>(),
		// GFCI_Tamper_Weather_Resistant: new Array<{ GFCI_Tamper_Weather_Resistant: string }>(),
		// GFCI_Self_Test: new Array<{ GFCI_Self_Test: string }>(),
		// No_of_Wires: new Array<{ No_of_Wires: string }>(),
		// No_of_Poles: new Array<{ No_of_Poles: string }>(),
		// Voltage_Rating: new Array<{ Voltage_Rating: string }>(),
		// Amperage_Rating: new Array<{ Amperage_Rating: string }>(),
		// Color: new Array<{ Color: string }>(),
		// Cable_Type: new Array<{ Cable_Type: string }>(),
		// Cable_Category_: new Array<{ Cable_Category_: string }>(),
		// Flammability_Rating: new Array<{ Flammability_Rating: string }>(),
		// Gauge: new Array<{ Gauge: string }>(),
		// Jacket_Material: new Array<{ Jacket_Material: string }>(),
		// No_Of_Pairs: new Array<{ No_Of_Pairs: string }>(),
		// Shield: new Array<{ Shield: string }>(),
		// Connector_Configurations: new Array<{ Connector_Configurations: string }>(),
		// Connector_Type: new Array<{ Connector_Type: string }>(),
		// Fiber_Category: new Array<{ Fiber_Category: string }>(),
		// Fiber_Cord_Type: new Array<{ Fiber_Cord_Type: string }>(),
		// Fiber_Count: new Array<{ Fiber_Count: string }>(),
		// Jacket_Color: new Array<{ Jacket_Color: string }>(),
		// No_Of_Connectors: new Array<{ No_Of_Connectors: string }>(),
	});

	useEffect(() => {
		if (props?.skuTree.length > 0) {
			let l1Options: any = [];
			let l2Options: any = [];
			let l3Options: any = [];
			let l4Options: any = [];
			let l5Options: any = [];
			let l6Options: any = [];
			let l7Options: any = [];
			let l8Options: any = [];
			let l9Options: any = [];
			let l10Options: any = [];
			props.skuTree &&
				props.skuTree[0].data.map((item: any, key: any) => {
					l1Options.push({ label: item.name, value: item.name });
				});
			props.skuTree[1] &&
				props.skuTree[1].data.map((item: any, key: any) => {
					l2Options.push({ label: item.name, value: item.name });
				});
			props.skuTree[2] &&
				props.skuTree[2].data.map((item: any, key: any) => {
					l3Options.push({ label: item.name, value: item.name });
				});
			props.skuTree[3] &&
				props.skuTree[3].data.map((item: any, key: any) => {
					l4Options.push({ label: item.name, value: item.name });
				});
			props.skuTree[4] &&
				props.skuTree[4].data.map((item: any, key: any) => {
					l5Options.push({ label: item.name, value: item.name });
				});
			props.skuTree[5] &&
				props.skuTree[5].data.map((item: any, key: any) => {
					l6Options.push({ label: item.name, value: item.name });
				});
			props.skuTree[6] &&
				props.skuTree[6].data.map((item: any, key: any) => {
					l7Options.push({ label: item.name, value: item.name });
				});
			props.skuTree[7] &&
				props.skuTree[7].data.map((item: any, key: any) => {
					l8Options.push({ label: item.name, value: item.name });
				});
			props.skuTree[8] &&
				props.skuTree[8].data.map((item: any, key: any) => {
					l9Options.push({ label: item.name, value: item.name });
				});
			props.skuTree[9] &&
				props.skuTree[9].data.map((item: any, key: any) => {
					l10Options.push({ label: item.name, value: item.name });
				});

			let temp: any = {};
			if (leanageValue.length > 10 && props.skuTree.length > 9) {
				for (let i = 11; i <= leanageValue.length; i++) {
					if (props.skuTree[i - 1]) {
						let j: any = [];
						props.skuTree[i - 1].data.map((item: any, key: any) => {
							j.push({ label: item.name, value: item.name });
						});
						temp[`l${i}`] = j;
					}
				}
			}

			setCategories({
				l1: l1Options,
				l2: l2Options,
				l3: l3Options,
				l4: l4Options,
				l5: l5Options,
				l6: l6Options,
				l7: l7Options,
				l8: l8Options,
				l9: l9Options,
				l10: l10Options,
				...temp,
			});
		}
	}, [props]);

	/* useEffect(() => {
    document.getElementById('l10')?.scrollIntoView({ behavior: 'smooth' });
  }, [props.skuTree]) */

	return (
		<>
			<div className="flex relative w-full top-[.1vh] pt-[0.7vh] px-[0.4vw] gap-x-[0.4vw] min-w-fit">
				{tree.length > 0 &&
					tree.map((category: any, index: number) => {
						return category?.isDataAvailable ? (
							<div
								className={`sub-heading-text variant-tree-filter flex items-center shadow-md over ${
									["l1", "l2", "l3", "l4"].includes(
										category.dataKey
									)
										? "taxonomyDropdown"
										: "attributeDropdown"
								} `}
								style={{
									width: "10vw",
									minWidth: "10vw",
									height: "6vh",
								}}
							>
								{/* <span className="capitalize">{category.dataKey}</span> */}
								<SelectPicker
									// size="md"
									data={
										categories[`${category?.dataKey}`]
											?.length
											? categories[`${category?.dataKey}`]
											: []
									}
									placeholder={category?.attributekey.toUpperCase()}
									onChange={(value: any) =>
										handleItemClick(
											value,
											category.dataKey,
											index,
											category.attributekey
										)
									}
									cleanable={false}
								/>
							</div>
						) : null;
					})}
				{relevantAttributes.map((i: any) => {
					return (
						<div
							className={`sub-heading-text variant-tree-filter flex items-center shadow-md  overflow-y-auto${
								["l1", "l2", "l3", "l4"].includes(i.dataKey)
									? "taxonomyDropdown"
									: "attributeDropdown"
							} `}
							style={{
								width: "10vw",
								minWidth: "10vw",
							}}
						>
							<SelectPicker
								data={[]}
								placeholder={i?.dataKey.toUpperCase()}
								disabled
								cleanable={false}
							/>
						</div>
					);
				})}
			</div>

			<div
				className={`taxonomy pt-[0.8vh] px-[0.4vw] min-w-fit w-full overflow-auto ${
					selected["l1"].length > 0 ? "h-[100%]" : "h-[100%]"
				}`}
			>
				{tree.length > 0 &&
					tree.map((category: any, index: number) => {
						return category?.isDataAvailable ? (
							<div className="flex flex-col textSmall">
								<div
									className="filter-flex"
									style={{ flex: "0 1" }}
								>
									<div
										className={`sub-heading-text fixed variant-tree-filter ${
											["l1", "l2", "l3", "l4"].includes(
												category.dataKey
											)
												? "taxonomyDropdown"
												: "attributeDropdown"
										} `}
										style={{
											width: "10vw",
											minWidth: "10vw",
											height: "10vh",
										}}
									></div>
								</div>
								<div
									className="category"
									id={category.dataKey}
									key={category.dataKey + index}
								>
									{category.data.map((item: any) => {
										return (
											<div
												key={item.name}
												className={
													selected[
														category?.attributekey
													]?.length > 0
														? item.name ==
														  selected[
																category
																	?.attributekey
														  ][0]
															? [
																	"l1",
																	"l2",
																	"l3",
																	"l4",
															  ].includes(
																	category?.dataKey
															  )
																? "item selected flex flex-col justify-between taxonomyItem bg-black"
																: "item selected flex flex-col justify-between attributeItem bg-black"
															: "item flex flex-col justify-between full-opacity bg-black"
														: "full-opacity item flex flex-col justify-between bg-black"
												}
												style={{
													border: `${
														index ===
														tree.length - 1
															? [
																	"l1",
																	"l2",
																	"l3",
																	"l4",
															  ].includes(
																	category?.dataKey
															  )
																? "1px solid #8dd8f9"
																: "1px solid #a4eb18ed"
															: "1px solid white"
													}`,
												}}
												onClick={() =>
													handleItemClick(
														item.name,
														category.dataKey,
														index,
														category.attributekey
													)
												}
											>
												<span className="w-full text-center font-[500] textSmall capitalize">
													{item.name}
												</span>
												<div className="flex justify-between w-full">
													<span>{item.skuCount}</span>
													<span>
														{numberFormatter(
															item.spend,
															0,
															"$"
														)}
													</span>
												</div>
											</div>
										);
									})}
								</div>
							</div>
						) : null;
					})}
				{relevantAttributes.map((rel: any, ind: any) => {
					return (
						<div
							className="category"
							id={rel.dataKey}
							key={rel.dataKey + ind}
						>
							{rel.data.map((item: any) => {
								return (
									<div
										key={item}
										className={
											"item flex flex-col justify-between"
										}
										style={{
											cursor: "default",
											opacity: ".7",
										}}
									>
										<span className="w-full text-center font-bold textSmall">
											{item}
										</span>
										<div className="flex justify-between w-full"></div>
									</div>
								);
							})}
						</div>
					);
				})}
			</div>
		</>
	);
};
export default ProductTaxonomy;
